import FieldLabel from "./FieldLabel";


export default function ModalField({
  label,
  renderValue,
}) {

  return (
    <div className="flex flex-col gap-1 w-full">
      <FieldLabel value={label} />
      {renderValue}
    </div>
  );
}
